import React, {
  useEffect,
  useRef,
  useState,
  useContext,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchCard from "../../../components/atoms/SearchCard";
import GlobalContext from "../../../context/GlobalContext";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import { Button } from "@material-ui/core";
import { throttle, debounce } from "lodash";
import { getSearchRegions } from "../../../API/search";

let map = null;
let markers = [];
let poly = null;
let isMouseDown = false;
let shapes = [];
let statePolygons = [];
let cityPolygon = null;
let searchInProgress = false;

// const allowedBounds = {
//   north: 74.83195098836619, // Top latitude - includes Alaska
//   south: 6.77489356669762, // Bottom latitude - includes Hawaii
//   west: -190.4210190643655, // Left longitude - extended to include all of Alaska
//   east: -60.610472189365524, // Right longitude
// };

const allowedBounds = {
  north: 74.83195098836619, // Top latitude
  south: 6.77489356669762, // Bottom latitude
  west: -177.4210190643655, // Left longitude
  east: -60.610472189365524, // Right longitude
};

const defaultCenter = {
  lat: 39.8283, // Center of the US (approximately)
  lng: -98.5795,
};

const FALLBACK_BOUNDS_WITH_ALASKA = {
  north: 76.34105848050334,
  south: -3.0327778567138814,
  east: -7.602665841134151,
  west: -209.92688459113413,
  lat: 50.87406898894131,
  lng: -108.76477521613414,
  zoom: 3,
};

const FALLBACK_BOUNDS_CONTINENTAL = {
  north: 54.90075033271595,
  south: 3.643035291524992,
  east: -47.06555646613415,
  west: -148.22766584113415,
  lat: 32.84101976487707,
  lng: -97.64661115363414,
  zoom: 4,
};

const readEnv = (key) =>
  typeof process !== "undefined" && process.env ? process.env[key] : "";

const getRegionBoundsPresets = () => {
  const width = window.innerWidth;
  const continentalViewport =
    typeof global.getDefaultViewportByWidth === "function"
      ? global.getDefaultViewportByWidth(false, width)
      : null;
  const alaskaViewport =
    typeof global.getDefaultViewportByWidth === "function"
      ? global.getDefaultViewportByWidth(true, width)
      : null;

  const usaBoundsContinental = continentalViewport
    ? {
        north: Number(continentalViewport.north),
        south: Number(continentalViewport.south),
        east: Number(continentalViewport.east),
        west: Number(continentalViewport.west),
        lat: Number(continentalViewport.lat),
        lng: Number(continentalViewport.long),
        zoom: Number(continentalViewport.zoomLevel),
      }
    : FALLBACK_BOUNDS_CONTINENTAL;

  const usaBoundsWithAlaska = alaskaViewport
    ? {
        north: Number(alaskaViewport.north),
        south: Number(alaskaViewport.south),
        east: Number(alaskaViewport.east),
        west: Number(alaskaViewport.west),
        lat: Number(alaskaViewport.lat),
        lng: Number(alaskaViewport.long),
        zoom: Number(alaskaViewport.zoomLevel),
      }
    : FALLBACK_BOUNDS_WITH_ALASKA;

  console.log("[Map Preset Selection]", {
    width,
    continentalPreset: continentalViewport?.presetKey || "fallback",
    alaskaPreset: alaskaViewport?.presetKey || "fallback",
    usaBoundsContinental,
    usaBoundsWithAlaska,
  });

  return {
    USA_BOUNDS_WITH_ALASKA: usaBoundsWithAlaska,
    USA_BOUNDS_WITH_ALASKA_AND_PR: usaBoundsWithAlaska,
    USA_BOUNDS_CONTINENTAL: usaBoundsContinental,
    USA_BOUNDS_CONTINENTAL_WITH_PR: usaBoundsContinental,
  };
};

const stateAbbrToFips = {
  AL: "01",
  AK: "02",
  AZ: "04",
  AR: "05",
  CA: "06",
  CO: "08",
  CT: "09",
  DE: "10",
  DC: "11",
  FL: "12",
  GA: "13",
  HI: "15",
  ID: "16",
  IL: "17",
  IN: "18",
  IA: "19",
  KS: "20",
  KY: "21",
  LA: "22",
  ME: "23",
  MD: "24",
  MA: "25",
  MI: "26",
  MN: "27",
  MS: "28",
  MO: "29",
  MT: "30",
  NE: "31",
  NV: "32",
  NH: "33",
  NJ: "34",
  NM: "35",
  NY: "36",
  NC: "37",
  ND: "38",
  OH: "39",
  OK: "40",
  OR: "41",
  PA: "42",
  RI: "44",
  SC: "45",
  SD: "46",
  TN: "47",
  TX: "48",
  UT: "49",
  VT: "50",
  VA: "51",
  WA: "53",
  WV: "54",
  WI: "55",
  WY: "56",
  AS: "60",
  GU: "66",
  MP: "69",
  PR: "72",
  VI: "78",
};

const GoogleMap = forwardRef((props, ref) => {
  const mapRef = useRef(null);
  const location = useLocation();
  const site_id = global?.storeDetails?.site_id;
  const { currentTime, headerLocation } = useContext(GlobalContext);

  const [propertys, setPropertys] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isDrawing, setIsDrawing] = useState(false);
  const currentZoomRef = useRef(null);
  const isUserInteractionRef = useRef(null);
  const [searchbarValue, setSearchbarValue] = useState("");
  const [zoom_lvl, setZoomlvl] = useState("");
  const zoomToStateByNameRef = useRef(null);

  const getDefaultViewport = () => {
    const defaultQuery = new URLSearchParams(global.defaultLocation || "");

    const defaultLat =
      parseFloat(defaultQuery.get("lat")) ||
      Number(global.defaultLat) ||
      defaultCenter.lat;
    const defaultLng =
      parseFloat(defaultQuery.get("long")) ||
      Number(global.defaultLong) ||
      defaultCenter.lng;
    const defaultNorth =
      parseFloat(defaultQuery.get("north")) ||
      Number(global.defaultNorth) ||
      allowedBounds.north;
    const defaultSouth =
      parseFloat(defaultQuery.get("south")) ||
      Number(global.defaultSouth) ||
      allowedBounds.south;
    const defaultEast =
      parseFloat(defaultQuery.get("east")) ||
      Number(global.defaultEast) ||
      allowedBounds.east;
    const defaultWest =
      parseFloat(defaultQuery.get("west")) ||
      Number(global.defaultWest) ||
      allowedBounds.west;
    const defaultZoom =
      parseInt(defaultQuery.get("zoom_level"), 10) ||
      Number(global.defaultZoomLevel) ||
      Number(props?.zoomLevel) ||
      4;

    return {
      center: { lat: defaultLat, lng: defaultLng },
      bounds: {
        north: defaultNorth,
        south: defaultSouth,
        east: defaultEast,
        west: defaultWest,
      },
      zoom: defaultZoom,
    };
  };

  useImperativeHandle(ref, () => ({
    zoomToStateByName: (stateName) => {
      if (zoomToStateByNameRef.current) {
        return zoomToStateByNameRef.current(stateName);
      }
      return false;
    },
  }));

  const debouncedHandleMapCenterChange = useMemo(
    () =>
      debounce((newPos, newBounds, newZoom, from) => {
        if (newPos && newBounds && !isDrawing) {
          // Special handling for very wide viewports (crossing date line)
          if (newBounds.west > newBounds.east) {
            const fixedBounds = { ...newBounds };
            if (fixedBounds.west > 0) {
              fixedBounds.west = fixedBounds.west - 360;
            }
            if (fixedBounds.east - fixedBounds.west > 360) {
              fixedBounds.east = fixedBounds.west + 359.9;
            }
            props.handleMapCenterChange(newPos, fixedBounds, newZoom, from);
          } else {
            props.handleMapCenterChange(newPos, newBounds, newZoom, from);
          }
        }
      }, 700),
    [props.handleMapCenterChange, isDrawing, zoom_lvl],
  );

  useEffect(() => {
    const checkResetAndApplyBounds = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const reset = urlParams.get("reset");

      if (reset === "true") {
        // Store reset coordinates before clearing
        const resetLat = parseFloat(urlParams.get("lat"));
        const resetLong = parseFloat(urlParams.get("long"));
        const resetNorth = parseFloat(urlParams.get("north"));
        const resetSouth = parseFloat(urlParams.get("south"));
        const resetEast = parseFloat(urlParams.get("east"));
        const resetWest = parseFloat(urlParams.get("west"));
        const resetZoom = parseInt(urlParams.get("zoom_level"), 10);

        clearAllMapBoundaries();

        // Apply bounds with reset coordinates if they exist
        if (
          Number.isFinite(resetNorth) &&
          Number.isFinite(resetSouth) &&
          Number.isFinite(resetEast) &&
          Number.isFinite(resetWest)
        ) {
          applyBoundsDebounced(
            {
              north: resetNorth,
              south: resetSouth,
              east: resetEast,
              west: resetWest,
            },
            false,
            false,
          );
        } else {
          applyBoundsDebounced(null, true, true);
        }

        // Clean up URL parameters
        urlParams.delete("reset");
        urlParams.delete("searchbar");
        urlParams.delete("search_attempted");
        urlParams.delete("north");
        urlParams.delete("south");
        urlParams.delete("east");
        urlParams.delete("west");
        urlParams.delete("lat");
        urlParams.delete("long");
        urlParams.delete("zoom_level");
        urlParams.delete("isState");
        urlParams.delete("isCity");
        urlParams.delete("isDirect");
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${urlParams.toString()}`,
        );
      }
    };
    checkResetAndApplyBounds();
  }, [location.search]);
  // const refocusMap = () => {
  //   if (mapRef.current) {
  //     mapRef.current.focus();
  //     mapRef.current.scrollIntoView({ block: "nearest", inline: "nearest" });
  //   }
  // };
  const initMapLoad = () => {
    if (!map) {
      const urlParams = new URLSearchParams(window.location.search);
      const defaultViewport = getDefaultViewport();
      const savedZoom =
        parseInt(urlParams.get("zoom_level"), 10) ||
        Number(props?.zoomLevel) ||
        Number(zoom_lvl) ||
        defaultViewport.zoom;

      setZoomlvl(savedZoom);
      let lat = parseFloat(urlParams.get("lat")) || defaultViewport.center.lat;
      let lng = parseFloat(urlParams.get("long")) || defaultViewport.center.lng;
      const north = parseFloat(urlParams.get("north"));
      const south = parseFloat(urlParams.get("south"));
      const east = parseFloat(urlParams.get("east"));
      const west = parseFloat(urlParams.get("west"));

      // Handle potential date line crossing in URL parameters
      let adjustedWest = west;
      if (west > east && west > 0) {
        adjustedWest = west - 360;
      }

      const mapOptions = {
        // zoom: savedZoom,
        center: { lat, lng },
        fullscreenControl: false,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
        mapTypeControl: false,
        gestureHandling: "greedy",
        zoomControl: true,
        // minZoom: zoom_lvl,
        // restriction: {
        //   latLngBounds: allowedBounds,
        // },
        // gestureHandling: "greedy",
      };

      try {
        map = new window.google.maps.Map(
          document.getElementById("map"),
          mapOptions,
        );

        // Add a listener to handle map idle events - this ensures the map is fully loaded
        window.google.maps.event.addListenerOnce(map, "idle", function () {
          currentZoomRef.current = savedZoom;

          // ALWAYS fetch from API on first load for proper adaptive zoom
          fetchAndApplyRegionBounds();

          if (!isDrawing) {
            loadStatePolygons();
          }

          // Check if there's a search query in URL and process it
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get("searchbar")) {
            // Delay slightly to ensure map is really ready
            setTimeout(() => {
              searchCityFromURL("searchQuery line no 186");
            }, 200);
          }
        });

        map.addListener("dragstart", () => {
          isUserInteractionRef.current = true;
        });

        map.addListener("dragend", () => {
          if (isUserInteractionRef.current) {
            let newPos = map.getCenter()?.toJSON();
            let newBounds = map.getBounds()?.toJSON();
            let currentZoom = map.getZoom();

            const urlParams = new URLSearchParams(window.location.search);
            // Only delete state/city flags, but preserve searchbar to avoid clearing user input
            urlParams.delete("isState");
            urlParams.delete("isCity");
            urlParams.delete("isDirect");
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}?${urlParams.toString()}`,
            );

            map.setCenter(newPos);

            debouncedHandleMapCenterChange(
              newPos,
              newBounds,
              currentZoom,
              "dragmap",
            );
            // refocusMap();
          }
          isUserInteractionRef.current = false;
        });

        map.addListener("zoom_changed", () => {
          const newZoom = map.getZoom();

          // Update page number in URL without triggering additional searches
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.set("page", "1");

          // Prevent adding search_attempted flag on zoom changes
          if (urlParams.has("search_attempted")) {
            urlParams.delete("search_attempted");
          }

          // Update the URL without triggering a navigation
          // const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
          // window.history.replaceState({}, "", newUrl);

          const searchbarValue = urlParams.get("searchbar");
          const hasSearchbar = searchbarValue && searchbarValue !== "";

          if (newZoom !== currentZoomRef.current && !hasSearchbar) {
            let newPos = map.getCenter()?.toJSON();
            let newBounds = map.getBounds()?.toJSON();

            // Don't trigger boundary searches when just zooming
            debouncedHandleMapCenterChange(
              newPos,
              newBounds,
              newZoom,
              "zoommap",
            );
            isUserInteractionRef.current = false;

            currentZoomRef.current = newZoom;

            // Only clear boundaries when zooming out significantly
            if (newZoom <= 5 && cityPolygon) {
              clearAllMapBoundaries();
            }
            // refocusMap();
            // Clear search-related URL parameters when zooming way out
          }
          // Remove the automatic clearing of searchbar params
          // This was causing the SearchBar input to be cleared unintentionally
          // setTimeout(() => {
          //   if (urlParams.has("searchbar")) {
          //     urlParams.delete("searchbar");
          //     urlParams.delete("search_attempted");
          //     urlParams.delete("isCity");
          //     urlParams.delete("isState");
          //     window.history.replaceState(
          //       {},
          //       "",
          //       `${window.location.pathname}?${urlParams.toString()}`
          //     );
          //   }
          // }, 2500);

          // Enforce minimum zoom level without triggering multiple events
          if (newZoom < zoom_lvl) {
            // Prevent infinite loop of zoom events
            window.google.maps.event.clearListeners(map, "zoom_changed");
            map.setZoom(zoom_lvl);
            currentZoomRef.current = zoom_lvl;

            // Re-add the listener after a short delay
            setTimeout(() => {
              // Re-add the zoom_changed listener
              map.addListener("zoom_changed", this); // 'this' refers to the current listener
            }, 100);
            return;
          }
        });
      } catch (error) {
        console.error("Error initializing map:", error);
      }
    }

    if (markers.length) {
      markers.forEach((marker) => marker.setMap(null));
      markers = [];
    }

    if (props.multipleLocation && locations.length > 0 && propertys.length) {
      let currentInfoWindow = null;

      locations.map((location) => {
        const marker = new window.google.maps.Marker({
          position: location.latlng,
          map: map,
          title: location.name,
        });
        markers.push(marker);
        marker.addListener("touchstart", (event) => {
          event.preventDefault();
          console.log("Touchstart on marker:", event);
        });
        const infoWindow = new window.google.maps.InfoWindow();
        const div = document.createElement("div");

        if (location) {
          ReactDOM.render(
            <SearchCard
              item={location}
              timercurrent={currentTime}
              site_id={site_id}
              from={"map"}
            />,
            div,
          );
          infoWindow.setContent(div);
        }

        marker.addListener("click", () => {
          if (currentInfoWindow) {
            currentInfoWindow.close();
          }
          infoWindow.open(map, marker);
          currentInfoWindow = infoWindow;
        });

        map.addListener("click", function () {
          infoWindow.close();
        });
      });
    }
  };

  const clearCityBoundaryOverlay = () => {
    if (cityPolygon) {
      if (Array.isArray(cityPolygon)) {
        cityPolygon.forEach((polygon) => polygon.setMap(null));
      } else {
        cityPolygon.setMap(null);
      }
      cityPolygon = null;
    }
  };

  const getAddressComponent = (components, type, key = "long_name") => {
    if (!Array.isArray(components)) return "";
    const component = components.find(
      (item) => Array.isArray(item.types) && item.types.includes(type),
    );
    return component?.[key] || "";
  };

  const buildBoundaryCandidates = (searchQuery, geocodeResult) => {
    const components = geocodeResult?.address_components || [];
    const countyRaw = getAddressComponent(
      components,
      "administrative_area_level_2",
    );
    const stateShort = getAddressComponent(
      components,
      "administrative_area_level_1",
      "short_name",
    );
    const stateLong = getAddressComponent(
      components,
      "administrative_area_level_1",
    );
    const locality =
      getAddressComponent(components, "locality") ||
      getAddressComponent(components, "postal_town") ||
      getAddressComponent(components, "administrative_area_level_3") ||
      getAddressComponent(components, "sublocality");

    const county = countyRaw
      ? countyRaw.toLowerCase().includes("county")
        ? countyRaw
        : `${countyRaw} County`
      : "";

    const rawCandidates = [
      county && `${county}, ${stateShort || stateLong}, USA`,
      locality && `${locality}, ${stateShort || stateLong}, USA`,
      locality && `${locality}, ${stateLong}, USA`,
      stateLong && `${stateLong}, USA`,
      searchQuery,
      searchQuery?.includes(",")
        ? searchQuery.split(",").slice(-3).join(",").trim()
        : "",
    ];

    const uniqueCandidates = [];
    const seen = new Set();
    rawCandidates
      .map((item) => (typeof item === "string" ? item.trim() : ""))
      .filter((item) => item.length >= 3)
      .forEach((item) => {
        const normalized = item.toLowerCase();
        if (!seen.has(normalized)) {
          seen.add(normalized);
          uniqueCandidates.push(item);
        }
      });

    return uniqueCandidates;
  };

  const sanitizeWhereValue = (value = "") => value.replace(/'/g, "''").trim();

  const fetchTigerLayerGeoJson = async (layerUrl, whereClause) => {
    const params = new URLSearchParams({
      where: whereClause,
      outFields: "*",
      returnGeometry: "true",
      outSR: "4326",
      resultRecordCount: "1",
      f: "geojson",
    });

    const response = await fetch(`${layerUrl}/query?${params.toString()}`);
    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    const features = Array.isArray(data?.features) ? data.features : [];
    const polygonFeature = features.find((feature) => {
      const type = feature?.geometry?.type;
      return type === "Polygon" || type === "MultiPolygon";
    });

    return polygonFeature?.geometry || null;
  };

  const fetchTigerBoundary = async (geocodeResult) => {
    const components = geocodeResult?.address_components || [];
    const stateShort = getAddressComponent(
      components,
      "administrative_area_level_1",
      "short_name",
    );
    const stateFips = stateAbbrToFips[stateShort?.toUpperCase()];
    if (!stateFips) {
      return null;
    }

    const countyRaw = getAddressComponent(
      components,
      "administrative_area_level_2",
    );
    const countyBase = countyRaw.replace(/\s+County$/i, "").trim();
    const locality =
      getAddressComponent(components, "locality") ||
      getAddressComponent(components, "postal_town") ||
      getAddressComponent(components, "administrative_area_level_3") ||
      getAddressComponent(components, "sublocality");

    const countyLayer =
      "https://tigerweb.geo.census.gov/arcgis/rest/services/TIGERweb/State_County/MapServer/1";
    const placesLayer =
      "https://tigerweb.geo.census.gov/arcgis/rest/services/TIGERweb/Places_CouSub_ConCity_SubMCD/MapServer/4";
    const cdpLayer =
      "https://tigerweb.geo.census.gov/arcgis/rest/services/TIGERweb/Places_CouSub_ConCity_SubMCD/MapServer/5";

    if (countyBase) {
      const escapedCounty = sanitizeWhereValue(countyBase);
      const countyWhere = `STATE='${stateFips}' AND (BASENAME='${escapedCounty}' OR NAME='${escapedCounty} County')`;
      const countyGeometry = await fetchTigerLayerGeoJson(
        countyLayer,
        countyWhere,
      );
      if (countyGeometry) {
        return countyGeometry;
      }
    }

    if (locality) {
      const escapedLocality = sanitizeWhereValue(locality);
      const placeWhere = `STATE='${stateFips}' AND BASENAME='${escapedLocality}'`;
      const placeGeometry = await fetchTigerLayerGeoJson(
        placesLayer,
        placeWhere,
      );
      if (placeGeometry) {
        return placeGeometry;
      }

      const cdpGeometry = await fetchTigerLayerGeoJson(cdpLayer, placeWhere);
      if (cdpGeometry) {
        return cdpGeometry;
      }
    }

    return null;
  };

  const fetchNominatimBoundary = async (query) => {
    if (!query) return null;

    const params = new URLSearchParams({
      q: query,
      format: "json",
      polygon_geojson: "1",
      addressdetails: "1",
      limit: "5",
      countrycodes: "us",
    });

    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?${params.toString()}`,
    );
    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    if (!Array.isArray(data) || !data.length) {
      return null;
    }

    return (
      data.find((item) => {
        const type = item?.geojson?.type;
        return type === "Polygon" || type === "MultiPolygon";
      }) || null
    );
  };

  const applyGeoJsonBoundary = (geojson, source = "searchcitymap") => {
    if (!geojson || !map || !window.google || !window.google.maps) {
      return false;
    }

    let coordinates;
    if (geojson.type === "Polygon") {
      coordinates = [
        geojson.coordinates[0].map(([lng, lat]) => ({ lat, lng })),
      ];
    } else if (geojson.type === "MultiPolygon") {
      coordinates = geojson.coordinates.map((poly) =>
        poly[0].map(([lng, lat]) => ({ lat, lng })),
      );
    } else {
      return false;
    }

    const validPaths = coordinates
      .map((path) =>
        path.filter(
          (point) =>
            typeof point.lat === "number" &&
            !isNaN(point.lat) &&
            typeof point.lng === "number" &&
            !isNaN(point.lng),
        ),
      )
      .filter((path) => path.length > 2);

    if (!validPaths.length) {
      return false;
    }

    clearCityBoundaryOverlay();

    if (statePolygons && statePolygons.length) {
      statePolygons.forEach((polygon) => {
        polygon.setOptions({
          fillOpacity: 0,
          strokeOpacity: 0,
          strokeWeight: 0,
        });
      });
    }

    cityPolygon =
      validPaths.length === 1
        ? new window.google.maps.Polygon({
            paths: validPaths[0],
            strokeColor: "#FF0000",
            strokeOpacity: 0.6,
            strokeWeight: 1.5,
            fillColor: "#FF0000",
            fillOpacity: 0.08,
            map: map,
            geodesic: true,
          })
        : validPaths.map(
            (path) =>
              new window.google.maps.Polygon({
                paths: path,
                strokeColor: "#FF0000",
                strokeOpacity: 0.6,
                strokeWeight: 1.5,
                fillColor: "#FF0000",
                fillOpacity: 0.08,
                map: map,
                geodesic: true,
              }),
          );

    const bounds = new window.google.maps.LatLngBounds();
    validPaths.forEach((path) => {
      path.forEach((point) => bounds.extend(point));
    });

    const center = bounds.getCenter();
    map.fitBounds(bounds);
    map.panTo(center);

    const newBounds = {
      north: bounds.getNorthEast().lat(),
      east: bounds.getNorthEast().lng(),
      south: bounds.getSouthWest().lat(),
      west: bounds.getSouthWest().lng(),
    };

    let targetZoom = map.getZoom();
    const latDiff = Math.abs(newBounds.north - newBounds.south);
    const lngDiff = Math.abs(newBounds.east - newBounds.west);
    const areaSize = latDiff * lngDiff;

    if (areaSize < 0.01) targetZoom = 13;
    else if (areaSize < 0.5) targetZoom = 10;
    else targetZoom = Math.min(8, targetZoom);

    if (window.innerWidth < 1300) {
      targetZoom += 1;
    }

    setTimeout(() => {
      if (map) {
        map.setZoom(targetZoom);
        map.setCenter(center);
        debouncedHandleMapCenterChange(
          center.toJSON(),
          newBounds,
          targetZoom,
          source,
        );
      }
    }, 200);

    return true;
  };

  const applyViewportFallback = (geometry, source = "searchcitymap") => {
    if (!geometry || !geometry.viewport || !map || !window.google?.maps) {
      return false;
    }

    const viewport = geometry.viewport;
    let north = viewport.northeast.lat;
    let south = viewport.southwest.lat;
    let east = viewport.northeast.lng;
    let west = viewport.southwest.lng;

    const centerLat = geometry?.location?.lat || (north + south) / 2;
    const centerLng = geometry?.location?.lng || (east + west) / 2;
    const minLatSpan = 0.08;
    const minLngSpan = 0.08;

    if (Math.abs(north - south) < minLatSpan) {
      north = centerLat + minLatSpan / 2;
      south = centerLat - minLatSpan / 2;
    }

    if (Math.abs(east - west) < minLngSpan) {
      east = centerLng + minLngSpan / 2;
      west = centerLng - minLngSpan / 2;
    }

    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(south, west),
      new window.google.maps.LatLng(north, east),
    );

    clearCityBoundaryOverlay();
    map.fitBounds(bounds);

    const center = bounds.getCenter();
    map.panTo(center);
    debouncedHandleMapCenterChange(
      center.toJSON(),
      bounds.toJSON(),
      map.getZoom(),
      source,
    );

    return true;
  };

  const resolveAndApplyBoundary = async (
    searchQuery,
    source = "searchcitymap",
  ) => {
    const apiKey = readEnv("REACT_APP_GOOGLE_API_KEY");
    if (!apiKey) {
      console.warn("Google API key is missing, cannot resolve boundaries");
      return false;
    }

    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        searchQuery,
      )}&key=${apiKey}`,
    );

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    if (!data || !data.results || !data.results.length) {
      return false;
    }

    const geocodeResult = data.results[0];
    const boundaryCandidates = buildBoundaryCandidates(
      searchQuery,
      geocodeResult,
    );

    let boundaryApplied = false;
    const tigerBoundary = await fetchTigerBoundary(geocodeResult);
    if (tigerBoundary) {
      boundaryApplied = applyGeoJsonBoundary(tigerBoundary, source);
    }

    for (const candidate of boundaryCandidates) {
      if (boundaryApplied) break;
      try {
        const boundaryResult = await fetchNominatimBoundary(candidate);
        if (boundaryResult?.geojson) {
          boundaryApplied = applyGeoJsonBoundary(
            boundaryResult.geojson,
            source,
          );
        }
      } catch (candidateError) {
        console.warn(
          "Boundary lookup failed for candidate:",
          candidate,
          candidateError,
        );
      }
    }

    if (!boundaryApplied) {
      boundaryApplied = applyViewportFallback(geocodeResult.geometry, source);
    }

    return boundaryApplied;
  };

  // Searches for a city based on URL parameters and displays it on the map
  const searchCityFromURL = (from) => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get("searchbar");
    const isState = urlParams.get("isState") === "true";
    const isCity = urlParams.get("isCity") === "true";
    const isDirect = urlParams.get("isDirect") === "true";
    const searchAttempted = urlParams.get("search_attempted") === "true";

    // If a search is already in progress, don't start another one
    if (searchInProgress) {
      console.log("Search already in progress, ignoring duplicate call");
      return;
    }

    if (!searchQuery || !searchQuery.trim()) {
      return;
    }

    if (!map || !window.google || !window.google.maps) {
      console.log("Map not ready, will retry shortly");
      setTimeout(() => {
        searchCityFromURL("searchQuery line no 369");
      }, 300);
      return;
    }

    // Set flag to prevent duplicate searches
    searchInProgress = true;

    // Mark that we've attempted this search to avoid infinite loops
    if (!searchAttempted) {
      urlParams.set("search_attempted", "true");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${urlParams.toString()}`,
      );
    }

    // Clear all boundaries first
    clearAllMapBoundaries();

    // Add fallback state detection
    const usStatesList = [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
      "Puerto Rico",
      "American Samoa",
      "District of Columbia",
      "Guam",
      "Northern Mariana Islands",
      "U.S. Virgin Islands",
      "Trust Territories",
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
      "PR",
      "AS",
      "DC",
      "GU",
      "MP",
      "VI",
      "TT",
    ];
    let isStateDetected = isState;
    if (!isStateDetected && searchQuery) {
      const sq = searchQuery.trim().toLowerCase();
      isStateDetected = usStatesList.some(
        (state) => state.toLowerCase() === sq,
      );
      if (isStateDetected) {
        console.log("Fallback: Detected state name in searchbar:", searchQuery);
      }
    }
    if (isStateDetected) {
      console.log("State search triggered for:", searchQuery);
      // Only for state searches, allow state boundaries to appear
      const stateFound =
        zoomToStateByNameRef.current &&
        zoomToStateByNameRef.current(searchQuery);
      searchInProgress = false;
      if (stateFound) {
        return;
      }
      // If not found, fall through to city search (optional)
      return;
    }

    try {
      if (isCity || isDirect) {
        console.log(
          `${isCity ? "City" : "Direct"} search triggered for:`,
          searchQuery,
        );
        (async () => {
          let applied = false;
          try {
            applied = await resolveAndApplyBoundary(
              searchQuery,
              isDirect ? "searchdirectmap" : "searchcitymap",
            );
          } catch (error) {
            console.error("Boundary search error:", error);
          } finally {
            // If the query could not be resolved to a map boundary (e.g. an
            // APN, partial text or any value Google can't geocode), still run
            // a property search so the user gets results or a "No Properties
            // Found" message instead of nothing happening.
            if (!applied && typeof props.handleSearchbarChange === "function") {
              props.handleSearchbarChange(searchQuery);
            }
            setTimeout(() => {
              searchInProgress = false;
            }, 500);
          }
        })();
        return;
      }

      // If no conditions matched, reset the flag
      searchInProgress = false;
    } catch (error) {
      searchInProgress = false;
      console.error("Search error:", error);
    }
  };

  // Loads and displays US state polygons on the map
  const loadStatePolygons = () => {
    statePolygons.forEach((polygon) => polygon.setMap(null));
    statePolygons = [];
    const usStatesGeoJson = require("./us-states.json");
    // Debug: Check the structure of the first feature
    if (usStatesGeoJson?.features?.length > 0) {
      const firstFeature = usStatesGeoJson.features[0];
    }

    console.log(
      "First few state names:",
      usStatesGeoJson?.features?.slice(0, 5).map((f) => f.properties?.NAME) ||
        [],
    );

    if (
      !usStatesGeoJson ||
      !usStatesGeoJson.features ||
      usStatesGeoJson.features.length === 0
    ) {
      console.error("GeoJSON is empty or invalid. Trying alternative path...");
      // Try alternative path
      try {
        const altGeoJson = require("../../../public/map_resources/us-states.json");
        console.log("Alternative GeoJSON loaded:", altGeoJson);
        if (
          altGeoJson &&
          altGeoJson.features &&
          altGeoJson.features.length > 0
        ) {
          usStatesGeoJson = altGeoJson;
        } else {
          console.error("Alternative GeoJSON also empty or invalid");
          return;
        }
      } catch (error) {
        console.error("Failed to load alternative GeoJSON:", error);
        return;
      }
    }

    const updatePolygonsVisibility = () => {
      const currentZoom = map.getZoom();
      statePolygons.forEach((polygon) => {
        if (currentZoom <= 8 && !isDrawing) {
          polygon.setMap(map);
          polygon.setOptions({
            strokeColor: "#000000",
            strokeOpacity: 0,
            strokeWeight: 0,
            fillColor: "#87CD87",
            fillOpacity: 0,
          });
        } else {
          polygon.setMap(null);
        }
      });
    };

    // Add a function to zoom to a state by name
    const zoomToStateByName = (stateName) => {
      // First clear ALL boundaries
      clearAllMapBoundaries();

      if (!stateName || !map) return false;

      // Check if this is a search from searchbar - in that case, let searchCityFromURL handle it
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get("searchbar");

      // Normalize search name
      let searchName = stateName.trim().toLowerCase().replace(/\s+/g, " ");

      // Safety check to avoid the toLowerCase error if features or properties are missing
      if (!usStatesGeoJson || !usStatesGeoJson.features) {
        console.error("GeoJSON missing or invalid");
        return false;
      }

      // Find the state by normalized name
      const stateFeature = usStatesGeoJson.features.find((feature) => {
        if (!feature || !feature.properties || !feature.properties.NAME) {
          return false;
        }
        const featureName = feature.properties.NAME.trim()
          .toLowerCase()
          .replace(/\s+/g, " ");
        return featureName === searchName;
      });

      if (!stateFeature) {
        console.log("State not found in GeoJSON:", searchName);
        const availableNames = usStatesGeoJson.features
          .map((f) => f.properties && f.properties.NAME)
          .filter(Boolean);
        console.log("Available state names in GeoJSON:", availableNames);
        return false;
      }
      console.log("State found:", stateFeature.properties.NAME);

      try {
        // Always create and add a new polygon for the found state
        const coordinates = stateFeature.geometry.coordinates;
        const polygonPaths =
          stateFeature.geometry.type === "Polygon"
            ? coordinates[0].map(([lng, lat]) => ({ lat, lng }))
            : coordinates.map((poly) =>
                poly[0].map(([lng, lat]) => ({ lat, lng })),
              );
        const newPolygon = new window.google.maps.Polygon({
          paths: polygonPaths,
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          strokeWeight: 1.5,
          fillColor: "#87CD87",
          fillOpacity: 0.2,
          map: map,
        });
        // Keep selected state highlight separate from base state polygons,
        // otherwise updatePolygonsVisibility will make it fully transparent.
        cityPolygon = newPolygon;

        // Calculate bounds for the state
        const bounds = new window.google.maps.LatLngBounds();
        if (stateFeature.geometry.type === "Polygon") {
          polygonPaths.forEach((point) => bounds.extend(point));
        } else {
          polygonPaths.forEach((path) =>
            path.forEach((point) => bounds.extend(point)),
          );
        }
        console.log("Polygon bounds:", bounds.toJSON());

        const stateCenter = bounds.getCenter();
        map.fitBounds(bounds);
        console.log(
          "After fitBounds, zoom:",
          map.getZoom(),
          "center:",
          map.getCenter(),
        );

        const newBounds = {
          north: bounds.getNorthEast().lat(),
          east: bounds.getNorthEast().lng(),
          south: bounds.getSouthWest().lat(),
          west: bounds.getSouthWest().lng(),
        };

        debouncedHandleMapCenterChange(
          stateCenter.toJSON(),
          newBounds,
          map.getZoom(),
          "state",
        );

        return true;
      } catch (error) {
        console.error("Error in zoomToStateByName:", error);
        return false;
      }
    };

    // Store the function in the ref instead of using props
    zoomToStateByNameRef.current = zoomToStateByName;

    usStatesGeoJson.features.forEach((feature) => {
      const coordinates = feature.geometry.coordinates;
      const polygonPaths =
        feature.geometry.type === "Polygon"
          ? coordinates[0].map(([lng, lat]) => ({ lat, lng }))
          : coordinates.map((poly) =>
              poly[0].map(([lng, lat]) => ({ lat, lng })),
            );

      const statePolygon = new window.google.maps.Polygon({
        paths: polygonPaths,
        strokeColor: "#000000",
        strokeOpacity: 0,
        strokeWeight: 0,
        fillColor: "#87CD87",
        fillOpacity: 0,
        map: null,
      });

      statePolygons.push(statePolygon);

      statePolygon.addListener("mouseover", () => {
        const currentZoom = map.getZoom();
        if (currentZoom <= 8 && !isDrawing) {
          statePolygon.setOptions({
            fillOpacity: 0.3,
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: "#87CD87",
            strokeColor: "#000000",
          });
        }
      });

      statePolygon.addListener("mouseout", () => {
        const currentZoom = map.getZoom();
        if (currentZoom <= 8 && !isDrawing) {
          statePolygon.setOptions({
            fillOpacity: 0,
            strokeOpacity: 0,
            strokeWeight: 0,
          });
        }
      });

      statePolygon.addListener("click", () => {
        clearAllMapBoundaries();

        const currentZoom = map.getZoom();
        if (currentZoom <= 8 && !isDrawing) {
          try {
            // Calculate bounds for the state
            const bounds = new window.google.maps.LatLngBounds();
            if (feature.geometry.type === "Polygon") {
              polygonPaths.forEach((point) => bounds.extend(point));
            } else {
              polygonPaths.forEach((path) =>
                path.forEach((point) => bounds.extend(point)),
              );
            }

            const stateCenter = bounds.getCenter();
            map.setCenter(stateCenter);

            const stateZoom = 6;
            map.setZoom(stateZoom);

            const newBounds = {
              north: bounds.getNorthEast().lat(),
              east: bounds.getNorthEast().lng(),
              south: bounds.getSouthWest().lat(),
              west: bounds.getSouthWest().lng(),
            };

            map.fitBounds(newBounds);

            debouncedHandleMapCenterChange(
              stateCenter.toJSON(),
              newBounds,
              stateZoom,
              "stateclickmap",
            );
          } catch (error) {
            console.error("Error handling state click:", error);
          }
        }
      });
    });

    updatePolygonsVisibility();

    map.addListener("zoom_changed", updatePolygonsVisibility);
  };

  // Applies map bounds with a debounce, either from props or URL
  const applyBoundsDebounced = (
    bounds,
    getBoundFromURL,
    forceDefault = false,
  ) => {
    let mapBounds;
    const defaultViewport = getDefaultViewport();

    // Clear city polygon when applying bounds from URL reset
    if (getBoundFromURL) {
      clearAllMapBoundaries();
    }

    if (forceDefault) {
      mapBounds = {
        south: Number(defaultViewport.bounds.south),
        west: Number(defaultViewport.bounds.west),
        north: Number(defaultViewport.bounds.north),
        east: Number(defaultViewport.bounds.east),
      };
    } else if (getBoundFromURL) {
      const urlParams = new URLSearchParams(window.location.search);
      mapBounds = {
        south: parseFloat(urlParams.get("south")),
        west: parseFloat(urlParams.get("west")),
        north: parseFloat(urlParams.get("north")),
        east: parseFloat(urlParams.get("east")),
      };

      // Reset should always fall back to absolute default bounds when URL bounds are absent/invalid
      if (
        isNaN(mapBounds.south) ||
        isNaN(mapBounds.west) ||
        isNaN(mapBounds.north) ||
        isNaN(mapBounds.east)
      ) {
        mapBounds = {
          south: Number(defaultViewport.bounds.south),
          west: Number(defaultViewport.bounds.west),
          north: Number(defaultViewport.bounds.north),
          east: Number(defaultViewport.bounds.east),
        };
      }
    } else if (bounds) {
      mapBounds = {
        south: Number(bounds.south),
        west: Number(bounds.west),
        north: Number(bounds.north),
        east: Number(bounds.east),
      };
    }

    // Normalize longitude values to ensure proper display
    if (mapBounds) {
      // Handle date line crossing
      if (mapBounds.west > mapBounds.east) {
        if (mapBounds.west > 0) {
          mapBounds.west = mapBounds.west - 360; // Convert to negative equivalent
        }
        // Ensure the bounds aren't too wide
        if (mapBounds.east - mapBounds.west > 360) {
          mapBounds.east = mapBounds.west + 359.9;
        }
      }

      // Ensure bounds are within reasonable limits
      mapBounds.north = Math.min(85, Math.max(-85, mapBounds.north));
      mapBounds.south = Math.min(85, Math.max(-85, mapBounds.south));
    }

    if (
      mapBounds &&
      !isNaN(mapBounds.north) &&
      !isNaN(mapBounds.south) &&
      !isNaN(mapBounds.east) &&
      !isNaN(mapBounds.west)
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      const savedZoom = forceDefault
        ? Number(defaultViewport.zoom)
        : parseInt(urlParams.get("zoom_level")) ||
          Number(props?.zoomLevel) ||
          Number(zoom_lvl) ||
          Number(defaultViewport.zoom);

      setZoomlvl(savedZoom);

      try {
        isUserInteractionRef.current = false;
        const latLngBounds = new window.google.maps.LatLngBounds(
          { lat: mapBounds.south, lng: mapBounds.west },
          { lat: mapBounds.north, lng: mapBounds.east },
        );
        map.fitBounds(latLngBounds);
        setTimeout(() => {
          map.setZoom(savedZoom);
          currentZoomRef.current = savedZoom;
          debouncedHandleMapCenterChange(
            map?.getCenter()?.toJSON(),
            map?.getBounds()?.toJSON(),
            savedZoom,
            "applyboundsmap",
          );
        }, 100);
      } catch (error) {
        console.error("Error applying bounds:", error, mapBounds);
      }
    } else {
      console.warn("Invalid bounds:", mapBounds);
    }
  };

  // Debounced function to handle searchbar input and display results on the map
  const debouncedHandleSearchbar = useMemo(
    () =>
      debounce((searchValue) => {
        if (
          searchValue &&
          searchValue.trim() !== "" &&
          window.google &&
          window.google.maps
        ) {
          // First clear all boundaries
          clearAllMapBoundaries();
          (async () => {
            try {
              const boundaryResult = await fetchNominatimBoundary(searchValue);
              if (!boundaryResult?.geojson) {
                console.warn("No polygon boundary found for:", searchValue);
                return;
              }
              applyGeoJsonBoundary(
                boundaryResult.geojson,
                "searchcitymaphover",
              );
            } catch (error) {
              console.error("Search error:", error);
            }
          })();
        } else {
          clearAllMapBoundaries();
        }
      }, 300),
    [debouncedHandleMapCenterChange],
  );

  // Starts drawing a polyline on the map when the user clicks
  const startDrawing = (event) => {
    if (!isDrawing) return;
    isMouseDown = true;

    const path = [event.latLng];
    poly = new window.google.maps.Polyline({
      path: path,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map: map,
    });
    window.google.maps.event.addListener(map, "mousemove", continueDraw);
  };

  // Stops drawing and converts the polyline to a polygon
  const stopDrawing = (event) => {
    if (!isDrawing || !poly || !isMouseDown) return;

    isMouseDown = false;
    google.maps.event.clearListeners(map, "mousemove");

    const path = poly.getPath();
    if (event.latLng) {
      path.push(event.latLng);
    }

    const startPoint = path.getAt(0);
    const endPoint = path.getAt(path.getLength() - 1);
    const threshold = 0.0001;

    if (
      Math.abs(startPoint.lat() - endPoint.lat()) < threshold &&
      Math.abs(startPoint.lng() - endPoint.lng()) < threshold
    ) {
      path.push(startPoint);
    } else {
      path.push(startPoint);
    }

    const polygon = new window.google.maps.Polygon({
      paths: path.getArray(),
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      map: map,
    });
    shapes.push(polygon);
    poly.setMap(null);
    poly = null;
  };

  // Handles mouse up event to stop drawing
  const handleMouseUp = (event) => {
    if (isMouseDown) {
      stopDrawing(event);
    }
  };

  // Continues drawing the polyline as the mouse moves
  const continueDraw = (event) => {
    if (!isDrawing || !poly || !isMouseDown) return;

    const path = poly.getPath();
    path.push(event.latLng);
  };

  // Initializes drawing event listeners on the map
  const initMap = () => {
    if (map) {
      window.google.maps.event.addListener(map, "mousedown", startDrawing);
      document.addEventListener("mouseup", handleMouseUp);
    }
  };

  // Resets all drawn shapes and map settings
  const resetDrawing = () => {
    clearAllMapBoundaries();

    // Reset URL parameters related to search (but preserve searchbar to avoid clearing user input)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("search_attempted")) {
      // Only delete search_attempted flag, but preserve searchbar
      urlParams.delete("search_attempted");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${urlParams.toString()}`,
      );
    }

    // Fetch region bounds from API on reset
    fetchAndApplyRegionBounds();

    // Reset UI state
    setIsDrawing(false);
    isMouseDown = false;

    // Re-enable map controls
    if (map) {
      map.setOptions({ draggable: true });
      loadStatePolygons();
    }
  };

  // Toggles drawing mode on the map
  const toggleDrawing = () => {
    setIsDrawing(true);
    if (map) {
      map.setOptions({ draggable: isDrawing });
      statePolygons.forEach((polygon) => polygon.setMap(null));
    }
  };

  // Gets bounds for all drawn shapes
  const getAllShapeBounds = (_shapes) => {
    return _shapes.map((__shape) => {
      let bounds = new window.google.maps.LatLngBounds();
      __shape.getPath().forEach((latLng) => {
        bounds.extend(latLng);
      });
      return {
        north: bounds.getNorthEast().lat(),
        east: bounds.getNorthEast().lng(),
        south: bounds.getSouthWest().lat(),
        west: bounds.getSouthWest().lng(),
      };
    });
  };

  // Applies bounds of drawn shapes to the parent component
  const applyBound = (_shapes) => {
    if (_shapes.length > 0) {
      const finalShapes = getAllShapeBounds(_shapes);
      props.handleMultipleBounds(finalShapes, "applyboundsmap");
    }
  };

  // Add the clearAllMapBoundaries function
  const clearAllMapBoundaries = () => {
    // Clear city polygon when reset is clicked
    clearCityBoundaryOverlay();

    // Reset state polygon styling and ensure they're not visible
    if (statePolygons && statePolygons.length > 0) {
      statePolygons.forEach((polygon) => {
        polygon.setOptions({
          fillOpacity: 0,
          strokeOpacity: 0,
          strokeWeight: 0,
          fillColor: "#87CD87",
          strokeColor: "#000000",
        });
      });
    }

    // Clear any user-drawn shapes
    if (shapes && shapes.length > 0) {
      shapes.forEach((shape) => shape.setMap(null));
      shapes = [];
    }

    // Clear polyline if it exists
    if (poly) {
      poly.setMap(null);
      poly = null;
    }
  };

  // Fetch regions data from backend API
  const fetchAndApplyRegionBounds = async () => {
    const {
      USA_BOUNDS_WITH_ALASKA,
      USA_BOUNDS_WITH_ALASKA_AND_PR,
      USA_BOUNDS_CONTINENTAL,
      USA_BOUNDS_CONTINENTAL_WITH_PR,
    } = getRegionBoundsPresets();

    try {
      const currentSiteId = site_id || localStorage.getItem("site_id") || "";
      const data = await getSearchRegions(currentSiteId);

      if (!data) {
        applyRegionBoundsToMap(USA_BOUNDS_WITH_ALASKA);
        return;
      }

      if (data.hasAlaska && data.hasPuertoRico) {
        applyRegionBoundsToMap(USA_BOUNDS_WITH_ALASKA_AND_PR);
      } else if (data.hasAlaska) {
        applyRegionBoundsToMap(USA_BOUNDS_WITH_ALASKA);
      } else if (data.hasPuertoRico) {
        applyRegionBoundsToMap(USA_BOUNDS_CONTINENTAL_WITH_PR);
      } else {
        applyRegionBoundsToMap(USA_BOUNDS_CONTINENTAL);
      }
    } catch (error) {
      console.error("Error fetching region bounds:", error);
      applyRegionBoundsToMap(USA_BOUNDS_WITH_ALASKA);
    }
  };

  // Helper function to apply region bounds to the map
  const applyRegionBoundsToMap = (bounds) => {
    if (!map || !window.google || !window.google.maps) return;

    // Set center and zoom directly from bounds configuration
    map.setCenter({ lat: bounds.lat, lng: bounds.lng });
    map.setZoom(bounds.zoom);

    setTimeout(() => {
      const newCenter = map.getCenter()?.toJSON();
      const newBounds = map.getBounds()?.toJSON();
      const newZoom = map.getZoom();

      currentZoomRef.current = newZoom;
      setZoomlvl(newZoom);
      debouncedHandleMapCenterChange(
        newCenter,
        newBounds,
        newZoom,
        "regionboundsmap",
      );
    }, 300);
  };

  useEffect(() => {
    const loadMap = () => {
      // Attempting to load map
      if (window.google && window.google.maps) {
        // Google Maps already loaded, initializing map
        initMapLoad();
      } else {
        // Loading Google Maps script
        if (!window.initNicholasMapLoad) {
          window.initNicholasMapLoad = () => {
            // Google Maps script loaded via callback
            initMapLoad();
          };
          const googleApiKey = readEnv("REACT_APP_GOOGLE_API_KEY");

          const script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&callback=initNicholasMapLoad&libraries=places`;
          script.async = true;
          script.defer = true;
          script.id = "google-maps-script";

          script.onload = () => {
            // Google Maps script loaded via onload
          };

          script.onerror = (err) => {
            // Google Maps script loading error
          };

          // Check if script is already added
          if (!document.getElementById("google-maps-script")) {
            document.head.appendChild(script);
          }
        } else {
          // Google Maps script already being loaded
        }
      }
    };

    loadMap();

    return () => {
      // Cleaning up map component
      debouncedHandleSearchbar.cancel();
      debouncedHandleMapCenterChange.cancel();

      if (map) {
        // Remove all listeners
        window.google.maps.event.clearInstanceListeners(map);
        map = null;
      }

      // Don't remove the script on unmount to avoid reloading issues
    };
  }, []);

  useEffect(() => {
    setLocations(props.locations);
  }, [props.locations]);

  useEffect(() => {
    if (props.viewProperties) {
      setPropertys(props.viewProperties);
    }
  }, [props.viewProperties]);

  useEffect(() => {
    if (isDrawing && map) {
      initMap();
    }
  }, [isDrawing, map]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const newSearchbarValue = urlParams.get("searchbar") || "";
    const reset = urlParams.get("reset");
    const searchAttempted = urlParams.get("search_attempted") === "true";
    const isDirect = urlParams.get("isDirect") === "true";

    // Handle reset separately
    if (reset === "true") {
      clearAllMapBoundaries();
      // Don't clear searchbarValue to preserve user input
      return;
    }

    // If search query changed, update state and trigger search
    if (newSearchbarValue !== searchbarValue) {
      // Update the local state
      setSearchbarValue(newSearchbarValue);

      // Only attempt to search if:
      // 1. Map is initialized
      // 2. We have a search query
      // 3. Search hasn't been attempted yet OR this is a direct search
      // 4. No search is currently in progress
      if (
        map &&
        window.google &&
        window.google.maps &&
        newSearchbarValue &&
        (!searchAttempted || isDirect) &&
        !searchInProgress
      ) {
        // Give a slight delay to ensure URL params are updated
        setTimeout(() => {
          if (!searchInProgress) {
            // For direct searches, trigger immediately
            if (isDirect) {
              urlParams.delete("search_attempted");
              window.history.replaceState(
                {},
                "",
                `${window.location.pathname}?${urlParams.toString()}`,
              );
            }
            searchCityFromURL("searchQuery from URL change");
          }
        }, 100);
      } else if (newSearchbarValue && !searchAttempted) {
        // Map not ready, will check for map initialization
        let retryCount = 0;
        const maxRetries = 3; // Reduce maximum retries
        const checkInterval = setInterval(() => {
          if (map && window.google && window.google.maps) {
            clearInterval(checkInterval);
            // Map now ready, triggering search

            // Prevent quick subsequent searches
            if (!searchInProgress) {
              const currentParams = new URLSearchParams(window.location.search);
              const isDirect = currentParams.get("isDirect") === "true";

              if (
                currentParams.get("searchbar") === newSearchbarValue &&
                (!currentParams.get("search_attempted") || isDirect)
              ) {
                searchCityFromURL("searchQuery from delayed map init");
              }
            }
          } else if (retryCount >= maxRetries) {
            clearInterval(checkInterval);
            console.warn("Map initialization timed out, search may fail");
          }
          retryCount++;
        }, 300); // 300ms interval
      }
    }
  }, [location.search, searchbarValue]);

  useEffect(() => {
    if (window.google && window.google.maps) {
      props.setLoaded(true);

      // Only reload the map if it's already initialized
      if (map) {
        initMapLoad();
      }
    } else {
      props.setLoaded(false);
    }
  }, [locations, propertys]);

  return (
    <>
      {isDrawing ? (
        <div className="drawPropertyBtns">
          <p className="drawPara">
            Draw a shape around the region(s) you would like to live in
          </p>
          <div className="d-flex align-items-center justify-content-end">
            <Button onClick={resetDrawing} className="mr-2">
              Cancel
            </Button>
            <Button onClick={() => applyBound(shapes)}>Apply</Button>
          </div>
        </div>
      ) : (
        <div className="drawSection">
          <Button onClick={toggleDrawing}>
            {isDrawing ? "Cancel Drawing" : "Draw"}
          </Button>
        </div>
      )}
      <div
        id="map"
        ref={mapRef}
        style={{
          width: props?.width || "auto",
          height: "100%",
        }}
      ></div>
    </>
  );
});

export default GoogleMap;
